import { useEffect } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import "./styles/globals.scss";
import { customTheme } from "./theme";
import Router from "routes";

export const App = () => {
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const activeEl = document.activeElement as HTMLInputElement | null;
      if (activeEl && activeEl.tagName === "INPUT" && activeEl.type === "number") {
        activeEl.blur();
      }
    };
    document.addEventListener("wheel", handleWheel, { passive: true });
    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <ChakraProvider theme={customTheme}>
      <Router />
    </ChakraProvider>
  );
};